<template>
  <section class="grid-block">
    <header>
      <span>Заявки</span>
      <VButton
        theme="link"
        :disabled="demandV2.isOptionsSelected"
        @click="DemandsV2Service.createRequest(demandV2, () => $emit(DemandRequest.Events.Created))"
      >
        Добавить заявку +
      </VButton>
    </header>

    <div
      v-if="isRequestsMoreThen1"
      class="content"
    >
      <VDataGridV2
        :data="demandV2.requests"
        :context-menu="demandRequestContextMenu"
        layout="fill"
        @row:dblclick="(row) => DemandsV2Service.editRequest(
          row,
          () => $emit(DemandRequest.Events.Updated),
          () => $emit(DemandRequest.Events.Deleted),
        )"
      >
        <VDataGridColumnV2
          id="desiredReceiptDate"
          label="Дата доставки"
          width="150px"
        >
          <template #default="{ row }">
            {{ row.desiredReceiptDate?.format() }}
          </template>
        </VDataGridColumnV2>

        <VDataGridColumnV2
          id="qty"
          label="Количество"
          width="120px"
        >
          <template #default="{ row }">
            {{ row.qtyDesired?.format(demandV2.unit) }}
          </template>
        </VDataGridColumnV2>

        <VDataGridColumnV2
          v-if="hasChosenOptions"
          id="sum"
          label="Сумма"
          width="150px"
        >
          <template #default="{ row }">
            {{ row.sumFullSeller?.format(demandV2.currencyCode) || '--' }}
          </template>
        </VDataGridColumnV2>
      </VDataGridV2>
    </div>

    <template v-else>
      <DemandRequestCreateForm :request="singleRequest" />

      <span>
        Сумма: {{ sumFullSeller?.format(demandV2.currencyCode) || '--' }}
      </span>
    </template>
  </section>
</template>

<script lang="ts">

import DemandV2                from '@/domains/DemandsV2/DemandV2';
import DemandRequest           from '@/domains/DemandsV2/DemandRequest';
import DemandsV2Service        from '@/domains/DemandsV2/DemandsV2Service';

import type ContextMenuItem    from '@/lib/components/VContextMenu/ContextMenuItem';

import DemandRequestCreateForm from '@/domains/DemandsV2/components/DemandV2Card/DemandV2RequestDialog/DemandRequestCreateForm.vue';
import Sum from "@/core/types/Sum";

export default defineComponent({
  name: 'DemandV2RequestsOptionSection',

  components: {
    DemandRequestCreateForm,
  },

  props: {
    demandV2: {
      type:     DemandV2,
      required: true,
    },
  },

  emits: [
    DemandRequest.Events.Created,
    DemandRequest.Events.Updated,
    DemandRequest.Events.Deleted,
  ],

  data() {
    return {
      DemandRequest,
      DemandsV2Service,
    };
  },

  computed: {
    hasChosenOptions(): boolean {
      return this.$core.utils.isNotEmptyArray(this.demandV2.chosenOptions);
    },

    isRequestsMoreThen1(): boolean {
      return this.demandV2.requests.length > 1;
    },

    singleRequest(): DemandRequest | null {
      if (this.isRequestsMoreThen1) {
        return null;
      }
      return this.demandV2.requests[0];
    },

    sumFullSeller(): Sum | null {
      if (this.isRequestsMoreThen1) {
        return null;
      }
      return this.singleRequest?.sumFullSeller ?? null;
    },

    /** Меню заявки. Логика пунктов — в сервисе; колбэки-эмиты прокидывает компонент. */
    demandRequestContextMenu(): ContextMenuItem<DemandRequest>[] {
      return DemandsV2Service.getDemandRequestContextMenu(
        () => this.$emit(DemandRequest.Events.Updated),
        () => this.$emit(DemandRequest.Events.Deleted),
      );
    },
  },
});
</script>
